// Milestones shown on the completion screen.
//
// Every one of these is a fact the app can prove from the shift's own
// completed-today data. The design spec offered "top 10% on Flowline 2" and a
// six-day streak; neither is derivable from anything the app reads, and a
// congratulation that turns out to be invented costs more trust than it buys.
//
// One a day, and none at all on Calm — a milestone that fires on every pod is
// wallpaper within a shift.

import type { CompletedPodVM } from '@/api/types';

export interface Milestone {
  title: string;
  sub: string;
}

/** Sydney date key, so "today" matches the shift rather than UTC. */
export function todayKey(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney' }).format(now);
}

/**
 * The milestone earned by finishing this pod, if any. `completed` should
 * already include the pod just signed off.
 */
export function milestoneFor(completed: CompletedPodVM[], stationName: string | null): Milestone | null {
  const count = completed.length;
  const where = stationName ?? 'this station';

  // Round numbers, which are the ones people actually notice.
  if (count > 0 && count % 10 === 0) {
    return { title: `${count} pods today`, sub: `That is ${count} through ${where} since midnight.` };
  }

  // A clean sheet is worth more than a fast one, but only once there is enough
  // of it to mean anything.
  const rftAll = count >= 5 && completed.every((c) => c.rft);
  if (rftAll) {
    return { title: 'Clean sheet', sub: `All ${count} pods through ${where} today were right first time.` };
  }

  return null;
}
